import { CustomerPage } from './../../../../models/customerPage.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OfferStatus } from '../../../../shared/enums/offer-status/offer-status.module';
import { Customer } from '../../../../models/customer.model';
import { RoleType } from '../../../../shared/enums/role-type/role-type.module';
import { CommonService } from '../../../../services/shared/common/common.service';
import { Page } from '../../../../models/page.model';
import { CompletionStatus } from '../../../../shared/enums/completion-status/completion-status.module';
import { MatExpansionPanel } from '@angular/material/expansion';
import { CustomerPageDataService } from '../../../../services/customerPageData/customerPageData.service';
import { SnackbarService } from '../../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoadingService } from '../../../../services/loading/loading.service';
import { AppStateService } from '../../../../services/shared/app-state/app-state.service';
import { ExportService } from '../../../../services/export/export.service';

@Component({
  selector: 'app-pages-list',
  templateUrl: './pages-list.component.html',
  styleUrl: './pages-list.component.css'
})
export class PagesListComponent implements OnInit {

  constructor(
    private common: CommonService,
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    private router: Router,
    private loadingService: LoadingService,
    private appState: AppStateService,
    private exportService: ExportService
  ) { }

  OfferStatus = OfferStatus;
  @Input() pageKeys!: CustomerPage[];
  @Input() customer!: Customer;
  @Input() userRole!: RoleType;
  @Input() sso!: string;
  @Input() pageId!: string | undefined;
  @Input() pagesMap!: Map<CustomerPage, CustomerPage[]>;
  @Output() emitCloseMenu = new EventEmitter;
  @Output() emitGoToBlock = new EventEmitter<number>();
  isMobile = window.innerWidth <= 1023;

  RoleType = RoleType;
  CompletionStatus = CompletionStatus;
  isPreview: boolean = false;
  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    this.isPreview = this.appState.getIsPreview();
  }

  onPageClick(parentPageId: string): void {
    if (!parentPageId || this.pageId == parentPageId) return;
    this.loadingService.show();

    const baseUrl = `/customer/${this.customer.id}/page/${parentPageId}`;
    const url = this.isPreview ? `${baseUrl}/preview` : baseUrl;

    const queryParams = this.isPreview
      ? { role: this.userRole.toString() }
      : this.sso
        ? { sso: this.sso }
        : null;

    setTimeout(() => {
      this.router.navigate([url], { queryParams });
      this.loadingService.hide();
      if (this.isMobile) {
        this.closeMenu();
      }
    }, 0);
  }

  onHeaderClick(event: Event, panel: MatExpansionPanel, parentPageId: string) {
    event.preventDefault();
    event.stopPropagation();
    const pageIdFromAttribute = parentPageId;
    if (this.pageId != pageIdFromAttribute) {
      this.onPageClick(parentPageId);
      if (this.isMobile) {
        this.closeMenu();
      }
    } else {
      if (!panel.expanded) {
        panel.open();
      } else {
        panel.close();
      }
    }
  }

  fetchPageStats(pageId: string): number | undefined {
    return this.customer.pages? this.common.fetchPageStats(this.customer.pages, pageId) : 0;
  }

  fetchPageStatus(pageId: string): CompletionStatus | undefined {
    return this.customer.pages ? this.common.fetchPageStatus(this.customer.pages, pageId) : 0;
  }

  handlePageBlockStats(blockId: string, blockIteration: number, percent: number): void {
    const blockElements = document.querySelectorAll<HTMLElement>(
      `.itemMenuBlock[data-blockid="${blockId}"][data-blockiteration="${blockIteration}"]`
    );

    blockElements.forEach(blockElement => {
      const step = blockElement.querySelector(".step");
      if (step) {
        step.className = "step"; // reset
        if (percent >= 100) {
          step.classList.add("complete");
        } else if (percent > 0 && percent < 100) {
          step.classList.add("progress");
        } else {
          step.classList.add("initial");
        }
      }
    });
  }

  isChildPageSelected(parentPage: Page): boolean {
    const childPages = this.pagesMap.get(parentPage);
    if (!childPages) {
      return false;
    }

    return childPages.some(childPage => this.pageId === childPage.id);
  }
  closeMenu(): void {
    this.emitCloseMenu.emit();
  }
  goToBlock(index: number): void {
    this.closeMenu();
    this.emitGoToBlock.emit(index);
  }

  onRedirectToPageConfig(event: Event, originId: string|undefined){
    event.preventDefault();
    event.stopPropagation();

    if(this.userRole == RoleType.ADMIN && originId)
    {
      window.open('/admin/pages/' + originId);
    }
  }

  onExportCustomerPageData(event: Event, page: CustomerPage){
    event.preventDefault();
    event.stopPropagation();

    if(page && page.id && this.customer.id && !this.isPreview)
    {
      this.loadingService.show();
      this.exportService.exportCustomerPageData(page.id, this.customer.id).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const blob = response.body!;
          const contentDisposition = response.headers.get('content-disposition');

          let fileName = 'Export.zip';

          if (contentDisposition) {
            let match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            } else {
              match = contentDisposition.match(/filename="?([^";]+)"?/i);
              if (match && match[1]) {
                fileName = match[1];
              }
            }
          }

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          this.loadingService.hide();
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error on fetching refBusiness lists'));
          this.loadingService.hide();
        }
      });
    }
  }
}
